import IOSBtn from '@/assets/images/vip/ios_btn.png';
import AndroidBtn from '@/assets/images/vip/android_btn.png';

function DownLoad() {
  function handleDownloadIOSApp() {
    window.location.href = 'https://deerbook.cn/app';
    window.location.href =
      'https://apps.apple.com/cn/app/%E5%A5%87%E9%B9%BF%E8%8B%B1%E8%AF%AD/id6505032677';
  }

  function handleDownloadAndroidApp() {
  
    window.location.href =
      'https://cdn2.deerbook.cn/apk/3.4.0_20_web_release_2024_09_07_02_50_all.apk';
  }

  return (
    <div
      style={{
        backgroundImage:
          'linear-gradient(180deg, rgba(255, 242, 158, 0.1) 0.82%, rgba(255, 242, 158, 0.2) 23.3%, #FFF29E 54.64%)',
      }}
      className='flex justify-between p-[18px] fixed bottom-0 left-0 right-0'
    >
      <img
        onClick={handleDownloadIOSApp}
        src={IOSBtn}
        alt=''
        className='w-[160px] h-[48px] mr-[12px]'
      />
      <img
        onClick={handleDownloadAndroidApp}
        src={AndroidBtn}
        alt=''
        className='w-[160px] h-[48px]'
      />
    </div>
  );
}

export default DownLoad;
